<aside class="sidebar" [class.sidebar--colapsado]="colapsado">
  <div class="sidebar-inner">
    <div class="brand-block flex items-start justify-between gap-2">
      <div>
        <app-jamar-logo [ancho]="122" [alto]="26" />
        <div class="fair-title">FERIA CHINA 2026</div>
        <div class="panel-subtitle">Panel de consolidación</div>
      </div>
      <button type="button" class="cerrar-sidebar-movil shrink-0" (click)="cerrar.emit()" aria-label="Cerrar panel">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="session-chip">
      <span class="status-dot live"></span>
      {{ perfil()?.nombre ?? 'Sin sesión' }} · capturando
    </div>

    <nav class="sidebar-nav">
      <a
        routerLink="/"
        routerLinkActive
        #rlaInicio="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        [class]="'nav-link ' + (rlaInicio.isActive ? 'activo' : '')"
      >
        <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="2" />
          <path d="M12 2a10 10 0 0 1 0 20" opacity=".35" />
          <path d="M16.24 7.76a6 6 0 0 1 0 8.48M7.76 16.24a6 6 0 0 1 0-8.48" />
        </svg>
        Proveedores en vivo
        <span class="nav-badge ml-auto">{{ totales.proveedores }}</span>
      </a>
      <a
        routerLink="/movil"
        routerLinkActive
        #rlaMovil="routerLinkActive"
        [class]="'nav-link ' + (rlaMovil.isActive ? 'activo' : '')"
      >
        <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2Z" />
          <circle cx="12" cy="13" r="3.5" />
        </svg>
        Capturar producto
      </a>
    </nav>

    <div class="sidebar-stats">
      <div class="stat-row">
        <span>Proveedores</span>
        <b>{{ totales.proveedores }}</b>
      </div>
      <div class="stat-row">
        <span>Productos capturados</span>
        <b>{{ totales.productos }}</b>
      </div>
      <div class="stat-row">
        <span>Telas registradas</span>
        <b>{{ totales.telas }}</b>
      </div>
      <div class="stat-row stat-row--alerta">
        <span>Sin precio de venta</span>
        <b>{{ totales.sinPrecio }}</b>
      </div>
    </div>

    <app-indicador-version />

    <div class="logout-block">
      <button (click)="cerrarSesion()" class="logout-link">
        <svg class="logout-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
        Cerrar sesión
      </button>
    </div>
  </div>

  <div class="sidebar-photo" aria-hidden="true"></div>
</aside>
